import { country } from '../commons';

export interface PhoneNumberCancel {
  type: 'cancel';
}

export interface PhoneNumberSave {
  type: 'save';
  phoneNumber: string;
  phoneNumberCountry: country;
}

export type PhoneNumberOutputData = PhoneNumberSave | PhoneNumberCancel;
